'use client';
import styles from './Interconnection.module.scss';
import Image from 'next/image';
import ImageBGPattern from '@/public/assets/Images/BGPattern.svg';
import InterconnectionCircleImage from '@/public/assets/Images/InterconnectionCircle.svg';
import React, { useState } from 'react';
import { useTranslations } from 'next-intl';

export const Interconnection = () => {
  const t = useTranslations('ui.interconnection');
  const segments = [1, 2, 3, 4, 5, 6];
  const [activeSegment, setActiveSegment] = useState<number | null>(null);
  const blockData = [
    {
      classWrapper: styles.topPartWrapper,
      items: [
        { text: t('blocks.first.one'), number: 1, type: 'odd' },
        { text: t('blocks.first.two'), number: 2, type: 'even' },
      ],
    },
    {
      classWrapper: styles.midPartWrapper,
      items: [
        { text: t('blocks.second.three'), number: 3, type: 'odd' },
        { text: t('blocks.second.four'), number: 4, type: 'even' },
      ],
    },
    {
      classWrapper: styles.bottomPartWrapper,
      items: [
        { text: t('blocks.third.five'), number: 5, type: 'odd' },
        { text: t('blocks.third.six'), number: 6, type: 'even' },
      ],
    },
  ];

  return (
    <section id="process" className={styles.container}>
      <figure>
        <Image
          className={styles.BGPattern}
          src={ImageBGPattern}
          alt="background plan gr"
          width={1400}
          height={837}
        />
      </figure>
      <h2>{t('header')}</h2>
      <div className={styles.content}>
        <div className={styles.circle}>
          <div className={styles.segments}>
            {segments.map((seg) => (
              <div
                key={seg}
                className={styles[`segment${seg}`]}
                style={{
                  opacity: activeSegment === seg ? 0 : 1,
                }}
              />
            ))}
          </div>

          {blockData.map((block) => (
            <div key={block.classWrapper} className={block.classWrapper}>
              <div className={styles.partContent}>
                {block.items.map((item) => (
                  <React.Fragment key={item.number}>
                    {item.type === 'even' && (
                      <div
                        className={`${styles.line} ${styles.even}`}
                        style={{
                          opacity:
                            activeSegment !== null
                              ? activeSegment === item.number
                                ? 0
                                : 1
                              : 1,
                        }}
                      >
                        <div className={styles.lineSmallCircle} />
                      </div>
                    )}

                    <div className={styles.lineElementWrapper}>
                      <div
                        className={styles.lineElement}
                        onMouseEnter={() => setActiveSegment(item.number)}
                        onMouseLeave={() => setActiveSegment(null)}
                      >
                        {item.text}
                        <div
                          className={`${styles.numerate} ${styles[item.type]}`}
                        >
                          {`0${item.number}`}
                        </div>
                      </div>
                    </div>

                    {item.type === 'odd' && (
                      <div
                        className={`${styles.line} ${styles.odd}`}
                        style={{
                          opacity:
                            activeSegment !== null
                              ? activeSegment === item.number
                                ? 0
                                : 1
                              : 1,
                        }}
                      >
                        <div className={styles.lineSmallCircle} />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}

          <div className={styles.circleLine} />
          <div className={styles.circleCenter}>
            <h6>{t('name')}</h6>
            <figure>
              <Image
                src={InterconnectionCircleImage}
                alt="mine plan gr"
                width={232}
                height={223}
              />
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
};
